import { useEffect, useState } from 'react';

export default function LandingPage({ onEnterApp, lang, onLang }) {

  const [currentLang, setCurrentLang] = useState(lang || 'es');

  const T = {
    es: {
      badge:        'Copa del Mundo 2026 · Álbum Digital',
      h1a:          'Lleva el registro de tu',
      h1b:          'álbum siempre',
      h1c:          'a la mano.',
      sub:          'Registra tus láminas, descubre qué te falta, y coordina intercambios con tus amigos — todo desde tu teléfono.',
      cta:          'Empezar gratis →',
      howBtn:       'Ver cómo funciona',
      features:     'Funciones',
      featTitle:    'TODO LO QUE NECESITAS PARA COMPLETAR TU ÁLBUM',
      featSub:      'Diseñado para coleccionistas que quieren ir más allá de pegar láminas.',
      f1t: 'SEGUIMIENTO EN TIEMPO REAL',
      f1d: 'Mira tu progreso por grupo, equipo y selección. Sabe exactamente cuánto te falta para completar cada sección.',
      f2t: 'COMPARTE CON TUS AMIGOS',
      f2d: 'Genera y envía tu lista de faltantes o repetidas en un toque. Coordina intercambios por WhatsApp o cualquier app.',
      f3t: 'BUSCA POR CÓDIGO O JUGADOR',
      f3d: 'Encuentra cualquier lámina al instante por su código de álbum o nombre del jugador. Nunca pierdas una de vista.',
      f4t: 'FILTRA TUS REPETIDAS',
      f4d: 'Ve todas tus repetidas de un vistazo, compáralas con lo que le falta a un amigo y organiza el intercambio perfecto.',
      how:          'Cómo funciona',
      howTitle:     'SIMPLE COMO PEGAR UNA LÁMINA',
      howSub:       'Sin complicaciones. En tres pasos tienes tu colección digital lista.',
      s1t: 'Crea tu cuenta gratis',
      s1d: 'Regístrate con tu correo. Tu colección se guarda en la nube y sincroniza entre dispositivos.',
      s2t: 'Toca para marcar láminas',
      s2d: 'Un toque para marcar como obtenida. Toca de nuevo para registrar repetidas. Así de simple.',
      s3t: 'Comparte e intercambia',
      s3d: 'Envía tu lista de faltantes. Figurix encuentra automáticamente las coincidencias con las repetidas de tus amigos.',
      trading:      'Intercambios',
      tradTitle:    'ENCUENTRA QUIÉN TIENE LO QUE TE FALTA',
      tradSub:      'Compara tu lista de faltantes con las repetidas de un amigo automáticamente. Figurix hace el cruce por ti.',
      p1t: 'Comparte tu lista de faltantes',
      p1d: 'Un toque. Tu lista sale por WhatsApp, Telegram o lo que uses.',
      p2t: 'Pega la lista de repetidas de un amigo',
      p2d: 'Figurix encuentra automáticamente las coincidencias.',
      p3t: 'Confirma el intercambio en un toque',
      p3d: 'Tu colección se actualiza instantáneamente.',
      today:        'Empieza hoy',
      ctaTitle:     'TU COLECCIÓN TE ESPERA',
      ctaSub:       'Gratis. Sin instalación. Funciona en cualquier teléfono. Empieza en menos de un minuto.',
      ctaBtn:       'Crear cuenta gratis →',
      trust:        'Sin tarjeta de crédito · Tus datos están seguros',
      disc:         'Esta aplicación es una herramienta de gestión de colecciones para fines educativos y personales.',
      statLam:      'Láminas', statPais: 'Países', statGrup: 'Grupos', statFree: 'Gratis',
      funciones:    'Funciones', comoFunciona: 'Cómo funciona', registrarse: 'Registrarse →',
      online: 'en línea', today2: 'Hoy',
      sync: '● Sincronizado', pct: '23% completado · 228 / 994',
      tengo: 'TENGO', faltan: 'FALTAN', reps: 'REPETIDAS', paises: 'PAÍSES',
      todas: 'Todas', faltantes: 'Faltantes', repetidas: 'Repetidas',
      logoOf: 'Logo Oficial', fwcSp: 'Especiales FWC', ccCol: 'CC · Coleccionables',
      buscar: 'Buscar equipo o código...',
      b1: '¿Tienes ARG-7 de De Paul?', b2: '¡Sí! Me faltan MEX-3 y BRA-11 😅',
      b3: 'Te paso mi lista 👇', b5: 'Figurix encontró 6 coincidencias 🎉',
      b6: '¡Hacemos el intercambio! 🔄', escribe: 'Escribe un mensaje...',
    },
    en: {
      badge:        'World Cup 2026 · Digital Album',
      h1a:          'Keep your album',
      h1b:          'tracking always',
      h1c:          'at hand.',
      sub:          "Track your stickers, discover what you're missing, and coordinate swaps with friends — all from your phone.",
      cta:          'Start for free →',
      howBtn:       'See how it works',
      features:     'Features',
      featTitle:    'EVERYTHING YOU NEED TO COMPLETE YOUR ALBUM',
      featSub:      'Built for collectors who want to go beyond just sticking stickers.',
      f1t: 'REAL-TIME TRACKING',
      f1d: 'See your progress by group, team and country. Know exactly how far you are from completing each section.',
      f2t: 'SHARE WITH FRIENDS',
      f2d: 'Generate and send your missing or duplicate list in one tap. Coordinate swaps via WhatsApp or any app.',
      f3t: 'SEARCH BY CODE OR PLAYER',
      f3d: 'Find any sticker instantly by album code or player name. Never lose track of one again.',
      f4t: 'FILTER YOUR DUPLICATES',
      f4d: "See all your duplicates at a glance, compare with what a friend needs, and organize the perfect swap.",
      how:          'How it works',
      howTitle:     'AS SIMPLE AS STICKING A STICKER',
      howSub:       'No fuss. Three steps to have your digital collection ready.',
      s1t: 'Create your free account',
      s1d: 'Sign up with your email. Your collection saves to the cloud and syncs across all your devices.',
      s2t: 'Tap to mark stickers',
      s2d: 'One tap to mark as owned. Tap again to register duplicates. That simple.',
      s3t: 'Share and swap',
      s3d: "Send your missing list. Figurix automatically finds matches with your friends' duplicates.",
      trading:      'Trading',
      tradTitle:    'FIND WHO HAS WHAT YOU NEED',
      tradSub:      "Automatically compare your missing list with a friend's duplicates. Figurix does the matching for you.",
      p1t: 'Share your missing list',
      p1d: 'One tap. Your list goes via WhatsApp, Telegram or whatever you use.',
      p2t: "Paste a friend's duplicate list",
      p2d: 'Figurix automatically finds the matches.',
      p3t: 'Confirm the swap in one tap',
      p3d: 'Your collection updates instantly.',
      today:        'Start today',
      ctaTitle:     'YOUR COLLECTION IS WAITING',
      ctaSub:       'Free. No installation. Works on any phone. Up and running in under a minute.',
      ctaBtn:       'Create free account →',
      trust:        'No credit card · Your data is safe',
      disc:         'This application is a collection management tool for educational and personal use.',
      statLam:      'Stickers', statPais: 'Countries', statGrup: 'Groups', statFree: 'Free',
      funciones:    'Features', comoFunciona: 'How it works', registrarse: 'Sign up →',
      online: 'online', today2: 'Today',
      sync: '● Synced', pct: '23% complete · 228 / 994',
      tengo: 'OWNED', faltan: 'MISSING', reps: 'DUPES', paises: 'COUNTRIES',
      todas: 'All', faltantes: 'Missing', repetidas: 'Dupes',
      logoOf: 'Official Logo', fwcSp: 'FWC Specials', ccCol: 'CC · Collectibles',
      buscar: 'Search team or code...',
      b1: 'Do you have ARG-7 (De Paul)?', b2: 'Yes! I need MEX-3 and BRA-11 😅',
      b3: "Here's my list 👇", b5: 'Figurix found 6 matches 🎉',
      b6: "Let's make the swap! 🔄", escribe: 'Type a message...',
    }
  };

  const t = T[currentLang];

  const switchLang = (l) => {
    setCurrentLang(l);
    if (onLang) onLang(l);
  };

  // Scroll reveal
  useEffect(() => {
    const els = document.querySelectorAll('.lp-reveal');
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const delay = parseInt(e.target.dataset.delay || 0);
          setTimeout(() => e.target.classList.add('lp-visible'), delay);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);

  // Header shadow on scroll
  useEffect(() => {
    const hdr = document.getElementById('lp-header');
    const handler = () => {
      if (hdr) hdr.style.boxShadow = window.scrollY > 20
        ? '0 4px 6px -1px rgba(0,0,0,0.10), 0 2px 4px -1px rgba(0,0,0,0.06)'
        : '0 4px 6px -1px rgba(0,0,0,0.06), 0 2px 4px -1px rgba(0,0,0,0.04)';
    };
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <div className="lp-root">

      {/* HEADER */}
      <header className="lp-header" id="lp-header">
        <a className="lp-logo" href="#">
          <div className="lp-logo-mark">
            <svg viewBox="0 0 24 24" fill="white" width="18" height="18">
              <path d="M9 8h2v8H9V8zm4 0h2v8h-2V8z"/>
            </svg>
          </div>
          <span className="lp-logo-name">FIGURIX</span>
        </a>
        <nav className="lp-nav">
          <a className="lp-nav-link" href="#lp-funciones">{t.funciones}</a>
          <a className="lp-nav-link" href="#lp-como">{t.comoFunciona}</a>
          <div className="lp-lang-toggle">
            <button className={`lp-lang-btn${currentLang==='es'?' lp-lang-active':''}`} onClick={()=>switchLang('es')}>ES</button>
            <button className={`lp-lang-btn${currentLang==='en'?' lp-lang-active':''}`} onClick={()=>switchLang('en')}>EN</button>
          </div>
          <button className="lp-btn-register" onClick={onEnterApp}>{t.registrarse}</button>
        </nav>
      </header>

      {/* HERO */}
      <section className="lp-hero">
        <div className="lp-orb lp-orb-r"/>
        <div className="lp-orb lp-orb-g"/>
        <div className="lp-orb lp-orb-b"/>
        <div className="lp-hero-inner">
          <div className="lp-badge">
            <span className="lp-badge-dot"/>
            {t.badge}
          </div>
          <h1 className="lp-h1">
            <span className="lp-gold">{t.h1a}</span><br/>
            <span>{t.h1b}</span><br/>
            <span className="lp-blue">{t.h1c}</span>
          </h1>
          <p className="lp-sub">{t.sub}</p>
          <div className="lp-hero-cta">
            <button className="lp-btn-primary" onClick={onEnterApp}>{t.cta}</button>
            <a className="lp-btn-ghost" href="#lp-como">{t.howBtn}</a>
          </div>
          <div className="lp-stat-strip">
            <div className="lp-stat-item">
              <div className="lp-stat-num">994</div>
              <div className="lp-stat-lbl">{t.statLam}</div>
            </div>
            <div className="lp-stat-div"/>
            <div className="lp-stat-item">
              <div className="lp-stat-num">48</div>
              <div className="lp-stat-lbl">{t.statPais}</div>
            </div>
            <div className="lp-stat-div"/>
            <div className="lp-stat-item">
              <div className="lp-stat-num">12</div>
              <div className="lp-stat-lbl">{t.statGrup}</div>
            </div>
            <div className="lp-stat-div"/>
            <div className="lp-stat-item">
              <div className="lp-stat-num">100%</div>
              <div className="lp-stat-lbl">{t.statFree}</div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="lp-features" id="lp-funciones">
        <div className="lp-features-inner">
          <div className="lp-features-header lp-reveal">
            <div className="lp-section-label">{t.features}</div>
            <h2 className="lp-section-title">{t.featTitle}</h2>
            <p className="lp-section-sub lp-center">{t.featSub}</p>
          </div>
          <div className="lp-features-grid">
            {[
              { icon:'📊', cls:'lp-icon-blue', title: t.f1t, desc: t.f1d, delay: 0 },
              { icon:'🔗', cls:'lp-icon-green', title: t.f2t, desc: t.f2d, delay: 75 },
              { icon:'🔍', cls:'lp-icon-gold', title: t.f3t, desc: t.f3d, delay: 150 },
              { icon:'🔄', cls:'lp-icon-red', title: t.f4t, desc: t.f4d, delay: 225 },
            ].map((f,i) => (
              <div key={i} className="lp-feature-card lp-reveal" data-delay={f.delay}>
                <div className={`lp-feature-icon ${f.cls}`}>{f.icon}</div>
                <div className="lp-feature-title">{f.title}</div>
                <p className="lp-feature-desc">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="lp-how" id="lp-como">
        <div className="lp-how-inner">
          <div className="lp-how-grid">
            <div className="lp-reveal">
              <div className="lp-section-label">{t.how}</div>
              <h2 className="lp-section-title">{t.howTitle}</h2>
              <p className="lp-section-sub">{t.howSub}</p>
              <div className="lp-steps">
                {[
                  { t: t.s1t, d: t.s1d },
                  { t: t.s2t, d: t.s2d },
                  { t: t.s3t, d: t.s3d },
                ].map((s,i) => (
                  <div key={i} className="lp-step">
                    <div className="lp-step-num">{i+1}</div>
                    <div>
                      <div className="lp-step-title">{s.t}</div>
                      <p className="lp-step-desc">{s.d}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* Phone mockup */}
            <div className="lp-phone-wrap lp-reveal">
              <div className="lp-phone-shell">
                <div className="lp-phone-screen">
                  <div className="lp-ph-topbar">
                    <span className="lp-ph-appname">FIGURIX | COPA DEL MUNDO 2026</span>
                    <div className="lp-ph-avatar">E</div>
                  </div>
                  <div className="lp-mini-cards">
                    {[
                      { bg:'rgba(166,255,187,0.45)', icon:<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="#00A651" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>, lbl: t.tengo, num:'826', sub:' / 994' },
                      { bg:'rgba(255,209,141,0.45)', icon:<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="#F5B800" strokeWidth="2"/><circle cx="12" cy="12" r="5" stroke="#F5B800" strokeWidth="2"/><circle cx="12" cy="12" r="1.5" fill="#F5B800"/></svg>, lbl: t.faltan, num:'168', sub:'' },
                      { bg:'rgba(255,186,211,0.45)', icon:<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M4 9l4-4 4 4M20 15l-4 4-4-4" stroke="#ec4899" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M8 5v14M16 5v14" stroke="#ec4899" strokeWidth="2" strokeLinecap="round"/></svg>, lbl: t.reps, num:'189', sub:'' },
                      { bg:'rgba(191,219,254,0.55)', icon:<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M4 5h10l-2 7H4L4 5z" fill="#3b82f6" opacity="0.9"/><path d="M4 12l2 6h8l2-6" stroke="#3b82f6" strokeWidth="1.5" strokeLinejoin="round"/><circle cx="9" cy="20" r="1" fill="#3b82f6"/><circle cx="15" cy="20" r="1" fill="#3b82f6"/></svg>, lbl: t.paises, num:'4', sub:' / 48' },
                    ].map((c,i) => (
                      <div key={i} className="lp-mini-card">
                        <div className="lp-mini-icon" style={{background:c.bg}}>{c.icon}</div>
                        <div className="lp-mini-lbl">{c.lbl}</div>
                        <div className="lp-mini-num">{c.num}<span className="lp-mini-sub">{c.sub}</span></div>
                      </div>
                    ))}
                  </div>
                  <div className="lp-ph-progress">
                    <div className="lp-ph-pbar"><div className="lp-ph-pfill" style={{width:'83%'}}/></div>
                    <div className="lp-ph-pct">83%</div>
                  </div>
                  <div className="lp-ph-search">
                    <svg width="9" height="9" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke="#9ca3af" strokeWidth="2.5"/><path d="M16.5 16.5L21 21" stroke="#9ca3af" strokeWidth="2.5" strokeLinecap="round"/></svg>
                    <span>{t.buscar}</span>
                  </div>
                  <div className="lp-ph-chips">
                    <div className="lp-ph-chip lp-ph-chip-on">{t.todas}</div>
                    <div className="lp-ph-chip">{t.faltantes}</div>
                    <div className="lp-ph-chip">{t.repetidas}</div>
                  </div>
                  <div className="lp-ph-rows">
                    <div className="lp-ph-row"><span>{t.logoOf}</span><span className="lp-ph-pct-badge">100%</span></div>
                    <div className="lp-ph-row" style={{opacity:0.85}}><span>{t.fwcSp}</span><span className="lp-ph-pct-badge">95%</span></div>
                    <div className="lp-ph-row lp-ph-row-cc"><span style={{color:'white'}}>{t.ccCol}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TRADING */}
      <section className="lp-trading">
        <div className="lp-trading-inner">
          <div className="lp-reveal">
            <div className="lp-section-label lp-label-dim">{t.trading}</div>
            <h2 className="lp-section-title lp-title-white">{t.tradTitle}</h2>
            <p className="lp-section-sub lp-sub-dim">{t.tradSub}</p>
            <div className="lp-tpills">
              {[
                { ico:'📤', t: t.p1t, d: t.p1d },
                { ico:'🔁', t: t.p2t, d: t.p2d },
                { ico:'✅', t: t.p3t, d: t.p3d },
              ].map((p,i) => (
                <div key={i} className="lp-tpill">
                  <div className="lp-tpill-ico">{p.ico}</div>
                  <div><strong className="lp-tpill-strong">{p.t}</strong><span className="lp-tpill-span">{p.d}</span></div>
                </div>
              ))}
            </div>
          </div>
          {/* WhatsApp chat */}
          <div className="lp-chat lp-reveal">
            <div className="lp-chat-header">
              <div className="lp-chat-avatar">⚽</div>
              <div>
                <div className="lp-chat-name">Carlos (Mundial 2026 🏆)</div>
                <div className="lp-chat-status">{t.online}</div>
              </div>
              <div className="lp-chat-dots">⋮</div>
            </div>
            <div className="lp-chat-body">
              <div className="lp-chat-date">{t.today2}</div>
              <div className="lp-bubble lp-bubble-in" data-time="10:32">{t.b1}</div>
              <div className="lp-bubble lp-bubble-out" data-time="10:33">{t.b2} <span className="lp-tick">✓✓</span></div>
              <div className="lp-bubble lp-bubble-in" data-time="10:33">{t.b3}</div>
              <div className="lp-bubble lp-bubble-code" data-time="10:34">MEX-3, MEX-8, BRA-11, BRA-4...</div>
              <div className="lp-bubble lp-bubble-out" data-time="10:35">{t.b5} <span className="lp-tick">✓✓</span></div>
              <div className="lp-bubble lp-bubble-in" data-time="10:35">{t.b6}</div>
            </div>
            <div className="lp-chat-input-bar">
              <div className="lp-chat-input-field">{t.escribe}</div>
              <div className="lp-chat-mic">🎤</div>
            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="lp-cta-section">
        <div className="lp-cta-inner lp-reveal">
          <div className="lp-section-label">{t.today}</div>
          <h2 className="lp-section-title">{t.ctaTitle}</h2>
          <p className="lp-section-sub lp-center">{t.ctaSub}</p>
          <button className="lp-btn-primary lp-btn-lg" onClick={onEnterApp}>{t.ctaBtn}</button>
          <p className="lp-trust">🔒 {t.trust}</p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="lp-footer">
        <div className="lp-footer-copy">© 2026 Emman Consulting SAS · Figurix</div>
        <div className="lp-footer-disc">{t.disc}</div>
      </footer>

    </div>
  );
}
